document.addEventListener('DOMContentLoaded', () => {
  const letterFilter = document.querySelector('[id*="Details-filter.p.m.custom.letra"]');
  const letterContainer = document.querySelector('#filtro-letter-container');

  if (letterFilter && letterContainer) {
    const clone = letterFilter.cloneNode(true);
    letterContainer.appendChild(clone);
    clone.open = true;

    let isReloading = false;

    const DELAY_REFRESH = 900;

    const refreshLetters = () => {
      if (isReloading) return;
      isReloading = true;

      setTimeout(() => {
        const sectionId = letterFilter
          .closest('[id^="shopify-section-"]')
          ?.id.replace('shopify-section-', '');

        if (!sectionId) {
          isReloading = false;
          return;
        }

        const baseUrl = `${window.location.pathname}${window.location.search}`;
        const joiner = baseUrl.includes('?') ? '&' : '?';
        const url = `${baseUrl}${joiner}section_id=${encodeURIComponent(sectionId)}`;

        fetch(url)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newletterFilter = doc.querySelector('[id*="Details-filter.p.m.custom.letra"]');

            if (newletterFilter) {
              letterFilter.innerHTML = newletterFilter.innerHTML;
              clone.innerHTML = newletterFilter.innerHTML;
              clone.open = true;
            }

            isReloading = false;
          })
          .catch(() => {
            isReloading = false;
          });
      }, DELAY_REFRESH);
    };

    document.addEventListener('click', (e) => {
      const clickedInput = e.target.closest('.facets__label input');
      if (clickedInput) {
        if (clickedInput.name !== 'filter.p.m.custom.letra') {
          refreshLetters();
        }
      }

      if (e.target.closest('.active-facets__button-remove')) {
        refreshLetters();
      }
    });

    clone.addEventListener('click', e => {
      const target = e.target.closest('input, label, button, a');
      if (!target) return;

      const selectorParts = [];
      if (target.name) selectorParts.push(`[name="${target.name}"]`);
      if (target.value) selectorParts.push(`[value="${target.value}"]`);
      const selector = selectorParts.join('');

      const originalTarget = letterFilter.querySelector(selector);
      if (originalTarget) originalTarget.click();
    });

    letterFilter.addEventListener('change', () => {
      const originalInputs = letterFilter.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      const cloneInputs = clone.querySelectorAll('input[type="checkbox"], input[type="radio"]');

      originalInputs.forEach((input, i) => {
        if (cloneInputs[i]) cloneInputs[i].checked = input.checked;
      });
    });

    const scrollContainer = document.querySelector('.facets-layout');
    if (!scrollContainer) return;

    const hasOverflow = scrollContainer.scrollWidth > scrollContainer.clientWidth;
    if (!hasOverflow) return;

    const dotsWrapper = document.createElement('div');
    dotsWrapper.className = 'scroll-dots';
    scrollContainer.insertAdjacentElement('afterend', dotsWrapper);

    const totalDots = 3;
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('span');
      dot.className = 'dot';
      if (i === 0) dot.classList.add('active');
      dotsWrapper.appendChild(dot);
    }

    const dots = dotsWrapper.querySelectorAll('.dot');

    scrollContainer.addEventListener('scroll', () => {
      const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      const scrollPercent = scrollContainer.scrollLeft / maxScroll;

      const activeIndex = Math.min(
        totalDots - 1,
        Math.floor(scrollPercent * totalDots)
      );

      dots.forEach((dot, i) => dot.classList.toggle('active', i === activeIndex));
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        const targetScroll = (i / (totalDots - 1)) * maxScroll;
        scrollContainer.scrollTo({
          left: targetScroll,
          behavior: 'smooth',
        });
      });
    });
  }
});